import {
  makeStyles,
  TableBody,
  TableFooter,
  TableRow
} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import { Skeleton } from "@material-ui/lab";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection, splitDateTime } from "@saleor/misc";
import { soldoutInCustompageList_soldoutInCustompage_edges_node } from "@saleor/soldoutcustompage/types/soldoutInCustompageList";
import { ListActions, ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface SoldoutCustomPageListProps extends ListProps, ListActions {
  soldoutCustomPages: soldoutInCustompageList_soldoutInCustompage_edges_node[];
}
const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      apply: {
        width: 80
      },
      publish: {
        width: 30
      },
      colName: {
        width: 300
      },
      displayoredr: {
        width: 80
      },
      updatedate: {
        width: 160
      }
    },
    apply: {
      color: "red"
    },
    table: {
      width: "auto"
    }
  }),
  { name: "CurrencyrateList" }
);

const numberOfColumns = 8;
const SoldoutCustomPageList: React.FC<SoldoutCustomPageListProps> = ({
  soldoutCustomPages,
  disabled,
  // isChecked,
  onNextPage,
  onPreviousPage,
  // onRowClick,
  pageInfo,
  selected,
  toggle,
  // toggleAll,
  toolbar
}) => {
  const classes = useStyles({});
  // eslint-disable-next-line no-console
  // console.log(soldoutCustomPages);
  return (
    <ResponsiveTable className={classes.table}>
      <TableHead
        colSpan={numberOfColumns}
        selected={selected}
        disabled={disabled}
        items={soldoutCustomPages}
        //   toggleAll={toggleAll}
        toolbar={toolbar}
      >
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Produc name"
            description="Produc name"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage defaultMessage="sku name" description="sku name" />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="Variant id"
            description="Variant id"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.publish}>
          <FormattedMessage
            defaultMessage="Published"
            description="Published"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.publish}>
          <FormattedMessage
            defaultMessage="Track Inventory"
            description="Track Inventory"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="soldout time"
            description="soldout time"
          />
        </TableCellHeader>
        <TableCellHeader className={classes.colName}>
          <FormattedMessage
            defaultMessage="online url"
            description="online url"
          />
        </TableCellHeader>
      </TableHead>
      <TableFooter>
        <TableRow>
          <TablePagination
            colSpan={numberOfColumns}
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            onNextPage={onNextPage}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onPreviousPage={onPreviousPage}
          />
        </TableRow>
      </TableFooter>
      <TableBody>
        {renderCollection(
          soldoutCustomPages,
          soldoutCustomPage => (
            <TableRow
              hover={!!soldoutCustomPage}
              key={soldoutCustomPage?.id}
              className={classes.link}
            >
              <TableCell padding="checkbox">
                <Checkbox
                  // checked={isSelected}
                  disabled={true}
                  disableClickPropagation
                  onChange={() => toggle(soldoutCustomPage.soldoutTime)}
                />
              </TableCell>
              <TableCell className={classes.colName}>
                {/* product name的数据 */}
                {maybe<React.ReactNode>(
                  () => soldoutCustomPage.productVariant.product.name,
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colName}>
                {/* sku name的数据 */}
                {maybe<React.ReactNode>(
                  () => soldoutCustomPage.productVariant.name,
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colName}>
                {/* Variant id的数据 */}
                {maybe<React.ReactNode>(
                  () => soldoutCustomPage.productVariant.sku,
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.publish}>
                {maybe<React.ReactNode>(
                  () =>
                    soldoutCustomPage.productVariant.isPublished ? "Yes" : "No",
                  <Skeleton />
                )}
              </TableCell>
              <TableCell className={classes.publish}>
                {maybe<React.ReactNode>(
                  () =>
                    soldoutCustomPage.productVariant.trackInventory
                      ? "Yes"
                      : "No",
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colDate}>
                {soldoutCustomPage && soldoutCustomPage.soldoutTime ? (
                  <p
                    className={classes.colDate}
                    title={
                      splitDateTime(
                        maybe(() => soldoutCustomPage.soldoutTime, "")
                      ).date +
                      " " +
                      splitDateTime(
                        maybe(() => soldoutCustomPage.soldoutTime, "")
                      ).time
                    }
                  >
                    {splitDateTime(
                      maybe(() => soldoutCustomPage.soldoutTime, "")
                    ).date +
                      " " +
                      splitDateTime(
                        maybe(() => soldoutCustomPage.soldoutTime, "")
                      ).time}
                  </p>
                ) : (
                  <Skeleton />
                )}
              </TableCell>

              <TableCell className={classes.colName}>
                {/* online url的数据 */}
                {maybe<React.ReactNode>(
                  () => soldoutCustomPage.custompage.url,
                  <Skeleton />
                )}
              </TableCell>
            </TableRow>
          ),
          () => (
            <TableRow>
              <TableCell colSpan={numberOfColumns}>
                <FormattedMessage defaultMessage="No products found" />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </ResponsiveTable>
  );
};
export default SoldoutCustomPageList;
